import React from 'react';
import { useSelector } from 'react-redux';
import Image from './image';

export default function Gallery() {
  const curIndex = useSelector((state) => state.data.curIndex);
  const selectedLocation = useSelector((state) => state.data.selectedLocation);

  console.log('selectedLocation', selectedLocation);

  const style = {
    display: curIndex === -1 ? 'none' : 'block',
  };

  function getDom() {
    if (selectedLocation.images && selectedLocation.images.length > 0) {
      return (
        <>
          {selectedLocation.images.map((obj, index) => {
            return (
              <Image
                key={obj.src}
                index={index}
                total={selectedLocation.images.length}
                location={selectedLocation.location}
                {...obj}
              />
            );
          })}
        </>
      );
    }
    return '';
  }

  return (
    <div className="gallery-wrap" style={style}>
      {getDom()}
    </div>
  );
}
